import {
  APP_TZ_IANA,
  formatAppDate,
  formatAppDateTime,
  formatCalendarDate,
  todayYmd,
  toDateTimeLocalValue,
  fromDateTimeLocalValue,
  nowDateTimeLocalValue
} from './appTimezone';

/** @deprecated Préférer formatAppDateTime */
export const formatDate = (dateString) =>
  formatAppDateTime(dateString, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });

export const formatDateShort = (dateString) =>
  formatAppDate(dateString, {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });

export const formatDateTime = (dateString) =>
  formatAppDateTime(dateString, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });

export {
  APP_TZ_IANA,
  formatAppDate,
  formatAppDateTime,
  formatCalendarDate,
  todayYmd,
  toDateTimeLocalValue,
  fromDateTimeLocalValue,
  nowDateTimeLocalValue
};
